import { endpoint } from './default';

// 取得所有目標
const getAllCommitment = () => endpoint.get('/commitment/all', {
  params: {
    tag: 'CodingWizard',
  },
});

// By CwID 取得單一學生目標
const getCommitmentByCwId = (cwid) => endpoint.get(`/commitment/${cwid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

// 建立目標
const createCommitment = (data) => endpoint.post('/commitment', data, {
  params: {
    tag: 'CodingWizard',
  },
});

// 更新目標
const updateCommitment = (data, cid) => endpoint.put(`/commitment/${cid}`, data, {
  params: {
    tag: 'CodingWizard',
  },
});

// 刪除目標
const deleteCommitment = (cid) => endpoint.delete(`/commitment/delete/${cid}`, null, {
  params: {
    tag: 'CodingWizard',
  },
});

export {
  getAllCommitment,
  getCommitmentByCwId,
  createCommitment,
  updateCommitment,
  deleteCommitment,
};
